import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import {
  HomeComponent,
  NotFoundComponent,
  HeaderComponent,
} from "./core/index";
import { HyperLocalLeadComponent } from "./hyper-local-lead/hyper-local-lead.component";
import { DigitalDeskActivenessComponent } from "./digital-desk-activeness/digital-desk-activeness.component";
import { CallDistributionComponent } from "./call-distribution/call-distribution.component";
import { AuthGuard, DIGMGaurd } from "./_helper";
import { ModelReportComponent } from "./model-report/model-report.component";
import { LeadTypeComponent } from "./lead-type/lead-type.component";
import { SourceMediumComponent } from "./source-medium/source-medium.component";
import { ComparativeReportComponent } from "./comparative-report/comparative-report.component";
import { LqsLeadComponent } from "./lqs-lead-report/lqs-lead.component";
import { VNMappingComponent } from "./vn-mapping/vn-mapping.component";

const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "home",
    children: [
      {
        path: "",
        component: HomeComponent,
      },
      {
        path: "hyperlocal-lead-report",
        component: HyperLocalLeadComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "digital-desk-activeness-report",
        component: DigitalDeskActivenessComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "call-distribution-report",
        component: CallDistributionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "model-report",
        component: ModelReportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "lead-type-report",
        component: LeadTypeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "hyperlocal-dealer-report",
        component: LqsLeadComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vn-mapping-report",
        component: VNMappingComponent,
        canActivate: [DIGMGaurd],
      },
      {
        path: "lead-source-report",
        component: SourceMediumComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "comparative-report",
        component: ComparativeReportComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
